import React, { useMemo, useState } from "react";
import { Box, Input, Popover, PopoverTrigger, PopoverContent, PopoverBody, List, ListItem, Text } from "@chakra-ui/react";

export default function SearchableSelect({
  items = [],
  value,
  onChange,
  placeholder = "Seçiniz",
  disabled = false,
  height = "48px",
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const selectedLabel = useMemo(() => {
    const it = items.find((i) => i.value === value);
    return it ? it.label : "";
  }, [items, value]);
  const filtered = useMemo(() => {
    if (!query) return items;
    const q = query.toLowerCase();
    return items.filter((i) => String(i.label).toLowerCase().includes(q));
  }, [items, query]);
  const handleSelect = (val) => {
    if (typeof onChange === "function") onChange(val);
    setOpen(false);
  };
  return (
    <Popover isOpen={open} onClose={() => setOpen(false)} placement="bottom-start" matchWidth>
      <PopoverTrigger>
        <Box
          as="button"
          onClick={() => !disabled && setOpen(true)}
          type="button"
          w="100%"
          h={height}
          border="1px solid"
          borderColor="gray.200"
          bg="white"
          borderRadius="12px"
          textAlign="left"
          px="12px"
          disabled={disabled}
        >
          <Text fontSize="sm" color={selectedLabel ? "gray.800" : "gray.500"}>
            {selectedLabel || placeholder}
          </Text>
        </Box>
      </PopoverTrigger>
      <PopoverContent w="100%">
        <PopoverBody>
          <Input
            placeholder="Ara..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
            mb={2}
            size="sm"
          />
          <Box maxH="220px" overflowY="auto" border="1px solid" borderColor="gray.100" borderRadius="8px">
            <List>
              {filtered.map((i) => (
                <ListItem
                  key={i.value}
                  px={3}
                  py={2}
                  _hover={{ bg: "gray.100", cursor: "pointer" }}
                  onClick={() => handleSelect(i.value)}
                >
                  <Text fontSize="sm">{i.label}</Text>
                </ListItem>
              ))}
              {filtered.length === 0 && (
                <ListItem px={3} py={2}>
                  <Text fontSize="sm" color="gray.500">Sonuç yok</Text>
                </ListItem>
              )}
            </List>
          </Box>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
